export enum FieldDiffStatus {
  Diff = 'DIFF',
  Empty = 'EMPTY',
  Match = 'MATCH',
}
